
import { useCallback } from 'react';
import './styles.css';
import TermosUso from './TermosUso';
import Conclusao from './Conclusao';
import { useController, UseControllerProvider } from './useController';

const Encerramento: React.FC = () => {

  const { step } = useController();

  const renderStep = useCallback(() => {
    const options = {
      termo: <TermosUso />,
      conclusao: <Conclusao />,
    }

    return options[step];
  }, [step]);

  return renderStep();
}

const EncerramentoWrapper: React.FC = () => (
  <UseControllerProvider>
    <Encerramento />
  </UseControllerProvider>
);

export default EncerramentoWrapper;